import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import debounce from '../utils/debounce';

export default class FeaturedStats {
  constructor(elem, APP) {
    this.elem = elem;
    this.stats = this.elem.querySelectorAll('.js-featured-stats-stat');
    this.deviceType = null;
    this.previousDeviceType = null;
    gsap.registerPlugin(ScrollTrigger);
    this.tls = [];
  }


  deviceEventController() {
    const isMobile = window.matchMedia('(max-width: 767px)').matches;
    const isDesktop = window.matchMedia('(min-width: 768px)').matches;

    if (isMobile) {
      this.deviceType = 'mobile';
      if (this.previousDeviceType === this.deviceType) return;
      // mobile setup, desktop teardown
      if (!this.tls.length) return;
      this.tls.forEach((tl) => {
        tl.kill();
      });
      this.tls = [];
    }
    if (isDesktop) {
      this.deviceType = 'desktop';
      if (this.previousDeviceType === this.deviceType) return;
      // desktop setup, mobile teardown
      this.desktopAnimation();
    }

    this.previousDeviceType = isMobile ? 'mobile' : 'desktop';
  }


  desktopAnimation() {
    this.stats.forEach((stat, index) => {
      const statNum = stat.querySelector('.js-featured-stats-stat-num');
      const statText = stat.querySelector('.js-featured-stats-stat-text');
      const isOdd = index % 2 === 0;

      gsap.set(statNum, { opacity: 0, x: (isOdd ? 100 : -100) });
      gsap.set(statText, { opacity: 0, x: (isOdd ? 100 : -100) });

      const tl = ScrollTrigger.create({
        trigger: stat,
        start: 'top 85%',
        onEnter: () => {
          gsap.to(statNum, {
            x: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out',
          });
          gsap.to(statText, {
            x: 0,
            opacity: 1,
            duration: 0.5,
            ease: 'power2.out',
          });
        },
      });

      this.tls.push(tl);
    });
  }

  init() {
    this.deviceEventController();
    window.addEventListener('resize', debounce(this.deviceEventController.bind(this), 200));
  }
}